import { DealCountdown } from '@entities/product';
import { useDealRemainingMs } from '@entities/product/lib/dealCountdown';
import { EXCLUSIVE_CAMPAIGN_ENDS_AT } from '@shared/config/exclusiveCampaign';

import styles from './ExclusiveOfferCountdown.module.css';

/** One countdown for the whole exclusive collection. */
export function ExclusiveOfferCountdown({ clockOffsetMs }: { clockOffsetMs: number }) {
  const remaining = useDealRemainingMs(EXCLUSIVE_CAMPAIGN_ENDS_AT, clockOffsetMs);
  if (remaining <= 0) return null;

  return (
    <section className={styles.banner} aria-label="Exclusive products offer">
      <div className={styles.copy}>
        <span className={styles.eyebrow}>Exclusive collection</span>
        <span className={styles.caption}>Ends Sep 28 at 1:00 PM EAT</span>
      </div>
      <DealCountdown
        endsAt={EXCLUSIVE_CAMPAIGN_ENDS_AT}
        clockOffsetMs={clockOffsetMs}
        className={styles.timer}
        compact
      />
    </section>
  );
}
